module.exports = __webpack_public_path__ + "static/media/slider-l6-360.c28b76b3.webp";